'use strict';

var ClassOrder = {
  'Literal': 1,
  'Collection': 3,
  'Formula': 4,
  'NamedNode': 5,
  'BlankNode': 6,
  'Variable': 7
};

module.exports = ClassOrder;


//////////////////
// WEBPACK FOOTER
// ./~/rdflib/lib/class-order.js
// module id = 9
// module chunks = 0